import type { IconData } from '@stacksjs/iconify-core'

export const bathtub: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8.487 2.04A3 3 0 0 1 11 5v2H5V5c0-1.039.528-1.955 1.33-2.493A2 2 0 0 0 3 4v6h16a1 1 0 0 1 0 2v1a6 6 0 0 1-4 5.659V19a1 1 0 0 1-2 0H7a1 1 0 0 1-2 0v-.341A6 6 0 0 1 1 13v-1a1 1 0 0 1 0-2V4a4 4 0 0 1 7.487-1.96M17 12H3v1a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4zM8 4a1 1 0 0 0-1 1h2a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default bathtub
